import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ArrowRight, Layers, Code, Link as LinkIcon, ExternalLink, MessageSquare, Phone, Mail, Database, RefreshCw, Calendar } from 'lucide-react';
export const Integrations = () => {
  return <div className="bg-black text-white min-h-screen font-sans" data-id="element-543">
      <Navbar data-id="element-544" />
      <main data-id="element-545">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-b from-black via-zinc-950 to-zinc-900 py-24 lg:py-32" data-id="element-546">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.05)_0,_transparent_70%)]" data-id="element-547"></div>
          <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(255,255,255,0.01)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(255,255,255,0.01)_1px,_transparent_1px)] bg-[size:40px_40px]" data-id="element-548"></div>
          {/* Decorative elements */}
          <div className="absolute top-20 left-10 w-64 h-64 bg-white/5 rounded-full filter blur-3xl" data-id="element-549"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-zinc-800/20 rounded-full filter blur-3xl" data-id="element-550"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-551">
            <div className="max-w-4xl mx-auto text-center" data-id="element-552">
              <div className="inline-block px-4 py-1 bg-white/5 backdrop-blur-sm rounded-full border border-white/10 mb-6" data-id="element-553">
                <span className="text-zinc-400 font-['Space_Grotesk'] text-sm tracking-wider" data-id="element-554">
                  SEAMLESS CONNECTIVITY
                </span>
              </div>
              <h1 className="font-['Playfair_Display'] text-5xl md:text-7xl font-light mb-8 leading-tight" data-id="element-555">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-zinc-400" data-id="element-556">
                  Integrations
                </span>
              </h1>
              <p className="font-['Space_Grotesk'] text-zinc-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-557">
                Connect LexSquire with your existing systems to create a unified
                workflow that enhances your firm's efficiency.
              </p>
            </div>
          </div>
        </section>
        {/* Main Content */}
        <section className="relative py-20" data-id="element-558">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.02)_0,_transparent_50%)]" data-id="element-559"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-560">
            <div className="max-w-4xl mx-auto" data-id="element-561">
              {/* Introduction Section */}
              <div className="mb-24 relative" data-id="element-562">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-563"></div>
                <div className="bg-gradient-to-br from-zinc-900/80 to-black/80 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-564">
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-8" data-id="element-565">
                    Designed for{' '}
                    <span className="text-white" data-id="element-566">Seamless Integration</span>
                  </h2>
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-567">
                    Our platform was designed to be a standalone service that
                    works with your law firm's existing communication channels.
                    LexSquire seamlessly integrates with your current systems,
                    enhancing your workflow without disrupting it.
                  </p>
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-568">
                    We provide a lightweight portal that captures all activity
                    with summary information that can be integrated into any
                    CRM, case management, or practice management platform that
                    your firm already uses.
                  </p>
                </div>
              </div>
              {/* Communication Channels Section */}
              <div className="mb-24 relative" data-id="element-569">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-570"></div>
                <div className="flex items-center mb-8" data-id="element-571">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-572">
                    <LinkIcon size={24} className="text-white" data-id="element-573" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-574">
                    Connect with Your{' '}
                    <span className="text-white" data-id="element-575">Communication Channels</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-576">
                  <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-577">
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-578">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-579">
                        <MessageSquare size={24} className="text-white" data-id="element-580" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-581">
                        Website Chat
                      </h3>
                      <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-582">
                        Replace your current webchat widget with our intelligent
                        system that combines AI and human expertise.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-583">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-584">
                        <Phone size={24} className="text-white" data-id="element-585" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-586">
                        Telephone System
                      </h3>
                      <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-587">
                        Our dedicated telephone number acts as a legal assistant
                        that calls can be routed to and through.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-588">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-589">
                        <Mail size={24} className="text-white" data-id="element-590" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-591">
                        Email Integration
                      </h3>
                      <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-592">
                        Works with the email addresses your team already uses,
                        ensuring a consistent communication flow.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Prebuilt Integrations Section */}
              <div className="mb-24 relative" data-id="element-593">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-594"></div>
                <div className="flex items-center mb-8" data-id="element-595">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-596">
                    <Layers size={24} className="text-white" data-id="element-597" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-598">
                    Prebuilt <span className="text-white" data-id="element-599">Integrations</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-600">
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-601">
                    We currently have prebuilt integrations with several popular
                    legal software platforms, allowing for immediate deployment
                    and seamless data flow.
                  </p>
                  <div className="grid md:grid-cols-2 gap-8" data-id="element-602">
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-603">
                      <div className="flex items-center mb-6" data-id="element-604">
                        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-605">
                          <span className="font-['Playfair_Display'] text-xl" data-id="element-606">
                            FV
                          </span>
                        </div>
                        <h3 className="font-['Playfair_Display'] text-2xl" data-id="element-607">
                          Filevine
                        </h3>
                      </div>
                      <p className="text-zinc-400 font-['Space_Grotesk'] mb-4" data-id="element-608">
                        Comprehensive case management system integration
                        allowing for automatic case creation and document
                        management.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-609">
                      <div className="flex items-center mb-6" data-id="element-610">
                        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-611">
                          <span className="font-['Playfair_Display'] text-xl" data-id="element-612">
                            LC
                          </span>
                        </div>
                        <h3 className="font-['Playfair_Display'] text-2xl" data-id="element-613">
                          LeadConnector
                        </h3>
                      </div>
                      <p className="text-zinc-400 font-['Space_Grotesk'] mb-4" data-id="element-614">
                        CRM integration for seamless lead tracking and
                        management throughout the client acquisition process.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-615">
                      <div className="flex items-center mb-6" data-id="element-616">
                        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-617">
                          <span className="font-['Playfair_Display'] text-xl" data-id="element-618">
                            VS
                          </span>
                        </div>
                        <h3 className="font-['Playfair_Display'] text-2xl" data-id="element-619">
                          Vinesign
                        </h3>
                      </div>
                      <p className="text-zinc-400 font-['Space_Grotesk'] mb-4" data-id="element-620">
                        Electronic signature integration allowing for immediate
                        document signing during the intake process.
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-621">
                      <div className="flex items-center mb-6" data-id="element-622">
                        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-623">
                          <span className="font-['Playfair_Display'] text-xl" data-id="element-624">
                            GHL
                          </span>
                        </div>
                        <h3 className="font-['Playfair_Display'] text-2xl" data-id="element-625">
                          GoHighLevel
                        </h3>
                      </div>
                      <p className="text-zinc-400 font-['Space_Grotesk'] mb-4" data-id="element-626">
                        Marketing automation platform integration for enhanced
                        lead nurturing and client communication.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Custom Integration Section */}
              <div className="mb-24 relative" data-id="element-627">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-628"></div>
                <div className="flex items-center mb-8" data-id="element-629">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-630">
                    <Code size={24} className="text-white" data-id="element-631" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-632">
                    Custom <span className="text-white" data-id="element-633">Integrations</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-634">
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm mb-8" data-id="element-635">
                    <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-636">
                      Beyond our prebuilt integrations, we can connect with any
                      software that provides APIs through custom integration.
                      Our team works with you to create tailored solutions that
                      fit your specific workflow.
                    </p>
                    <div className="grid md:grid-cols-3 gap-6" data-id="element-637">
                      <div className="bg-black/40 p-6 rounded-sm text-center" data-id="element-638">
                        <Database size={28} className="text-white mx-auto mb-4" data-id="element-639" />
                        <h4 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-640">
                          Data Transfer
                        </h4>
                        <p className="text-zinc-400 text-sm" data-id="element-641">
                          Seamless data flow between systems
                        </p>
                      </div>
                      <div className="bg-black/40 p-6 rounded-sm text-center" data-id="element-642">
                        <RefreshCw size={28} className="text-white mx-auto mb-4" data-id="element-643" />
                        <h4 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-644">
                          Workflow Automation
                        </h4>
                        <p className="text-zinc-400 text-sm" data-id="element-645">
                          Trigger actions across platforms
                        </p>
                      </div>
                      <div className="bg-black/40 p-6 rounded-sm text-center" data-id="element-646">
                        <LinkIcon size={28} className="text-white mx-auto mb-4" data-id="element-647" />
                        <h4 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-648">
                          Custom Connectors
                        </h4>
                        <p className="text-zinc-400 text-sm" data-id="element-649">
                          Built specifically for your needs
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Final CTA Section */}
              <div className="relative mb-20" data-id="element-650">
                <div className="absolute inset-0 bg-gradient-to-r from-zinc-900/50 via-zinc-800/50 to-zinc-900/50 rounded-sm blur" data-id="element-651"></div>
                <div className="relative bg-gradient-to-br from-zinc-900 to-zinc-800 p-10 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-652">
                  <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-653">
                    <div className="mb-6 md:mb-0 md:mr-8" data-id="element-654">
                      <div className="flex items-center mb-4" data-id="element-655">
                        <Calendar size={24} className="text-white mr-3" data-id="element-656" />
                        <h3 className="font-['Playfair_Display'] text-2xl font-light" data-id="element-657">
                          Schedule a Demo & Integration Call
                        </h3>
                      </div>
                      <p className="font-['Space_Grotesk'] text-white text-lg" data-id="element-658">
                        Let us show you how LexSquire can integrate with your
                        existing systems to create a seamless workflow.
                      </p>
                    </div>
                    <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-8 py-4 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center whitespace-nowrap" data-id="element-659">
                      Schedule Now
                      <ArrowRight size={18} className="ml-2" data-id="element-660" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-661" />
    </div>;
};